import type { FilterList } from 'src/types'

export const vists = [{ label: 'Mese', value: 7 }, { label: 'Anno', value: 4 }]
export const vistGroups = [{ label: 'Filiale', value: 'office' }, { label: 'Provenienza', value: 'provenience' }]

export const filtersMap: FilterList = {
  generali: {
    icon: 'mdi-cart',
    label: 'Generali',
    keys: ['statuses', 'offices', 'proveniences'],
  },
  ruoli_gestiti: {
    icon: 'mdi-format-list-bulleted-type',
    label: 'Ruoli Gestiti',
    keys: [],
    model: 'froles',
  },
}

export const paymentModes = [
  { mode: 'Sociale', label: 'Sociale' },
  { mode: 'Privata', label: 'Privato' },
  { mode: 'Riconducibille', label: 'Riconducibile' },
] as const

export const dataFields = [
  { label: 'Data Ordine', value: 'DataDocumento' },
  { label: 'Data Consegna', value: 'DataConsegnaCliente' },
  { label: 'Data Evoluzione Ordine', value: 'DataVariazioneStato' },
]
